import { useEffect } from 'react';

import { UploadData } from '../../../../../components/data-importer/UploadData';
import { StopDTO } from '../../../../../domain/stop/StopDTO';
import { useRetrieveActiveProject } from '../../../../../hooks/project/useRetrieveActiveProject';
import { useCreateStops } from '../../../../../hooks/stop/useCreateStops';
import { useRetrieveAllSupervisors } from '../../../../../hooks/supervisor/useRetrieveAllSupervisors';
import { StopMapper } from '../../../../../mappers/stop/StopMapper';
import { CreateStopsList } from './fields/CreateStopsList';

interface UploadStopsDataProps {
  createStopsList: CreateStopsList;
  onComplete: () => void;
}

export const UploadStopsData = ({ createStopsList, onComplete }: UploadStopsDataProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { data: projectSupervisors } = useRetrieveAllSupervisors();
  const { run: createStops, isLoading, error, success } = useCreateStops();

  useEffect(() => {
    if (activeProject?.custom_fields) {
      // Map supervisors to Record<"short_id", "id">
      const supervisorsMap = (projectSupervisors ?? []).reduce((acc, supervisor) => {
        acc[supervisor.short_id] = supervisor.id;
        return acc;
      }, {} as Record<string, string>);

      const parseSupervisors = (stop: StopDTO, supervisorsMap: Record<string, string>) => {
        const supervisorsIds = (stop.supervisors ?? []).map((supervisor) => supervisorsMap[supervisor]);
        stop.supervisors = supervisorsIds;
      };

      createStops({
        stops: createStopsList.getStops().map((stop) => {
          parseSupervisors(stop, supervisorsMap);
          if (stop.pickup) {
            parseSupervisors(stop.pickup, supervisorsMap);
          }
          return StopMapper.toDomain(stop, activeProject.custom_fields!);
        }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      onComplete();
    }
  }, [onComplete, success]);

  return <UploadData loading={isLoading} error={error} />;
};
